import { apiClient } from './api'

export interface AnalyticsInsight {
  severity: 'critical' | 'warning' | 'positive' | 'info'
  /** Present on newer APIs; used to localize — title/detail are the English fallback */
  code?: string
  params?: Record<string, string | number>
  title: string
  detail: string
}

export interface AnalyticsOverview {
  generatedAt: string
  months: number
  kpis: {
    sites: number
    totalHives: number
    liveHives: number
    deadHives: number
    healthRate: number
    queenRightRate: number | null
    totalHoney: number
    openAlerts: number
    gateways: number
    onlineGateways: number
    activeDevices: number
  }
  healthDistribution: { name: string; value: number }[]
  healthTrend: { month: string; healthRate: number | null }[]
  varroaTrend: { month: string; varroa: number | null }[]
  harvestTrend: { month: string; quantity: number }[]
  harvestByType: { name: string; value: number }[]
  treatmentsByType: { name: string; value: number }[]
  alertsByType: { error: number; warning: number; info: number }
  deviceHealth: {
    gateways: number
    onlineGateways: number
    offlineGateways: number
    lowBatteryGateways: number
    sensors: number
    sensorTrendDist: Record<string, number>
  }
  yardRanking: {
    id: string
    name: string
    hives: number
    healthRate: number
    dead: number
    lastVisit: string | null
    openAlerts: number
    deviceStatus: string | null
  }[]
  insights: AnalyticsInsight[]
}

export function getAnalyticsOverview(months = 12) {
  return apiClient.get<AnalyticsOverview>('/analytics/overview', { params: { months } })
}
